import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { Document } from '@apps/pata/domain/models';
import { PataConstants } from '@apps/pata/pata.constants';

export const PataCopilDocumentFeatureKey = 'copildocs';

export type IDocumentState = EntityState<Document>;
export const documentsAdapter: EntityAdapter<Document> = createEntityAdapter({
    selectId: (document: Document): string =>
        document.documentId ?? document.directoryId
});
const documentsInitialState: IDocumentState = documentsAdapter.getInitialState({});

export interface IPataCopilDocumentsState {
    documents: IDocumentState;
    isLoading: boolean;
    isEmpty: boolean;
    isOups: boolean;
    isLoaded: boolean;
    currentDirectoryId: string;
    parentDirectoryId: string;
    paths: string[];
    qsWord: string;
}

export const PataCopilDocumentsInitialState: IPataCopilDocumentsState = {
    documents: documentsInitialState,
    isLoading: true,
    isEmpty: false,
    isOups: false,
    isLoaded: false,
    currentDirectoryId: PataConstants.RootNodeGuid,
    parentDirectoryId: null,
    paths: [],
    qsWord: ''
};
